import { createContext } from 'react';

export const HomeContext = createContext<HomeContextProps>({
	isAuthenticated: false,
	isMenuOpen: false,
	setAuthIsOpen: () => {},
	setShowInstallation: () => {},
	onClickLogOut: () => {},
	setShowLogout: () => {},
	setIsMenuOpen: () => {},
	toggleMenu: () => {},
});

interface HomeContextProps {
	isAuthenticated: boolean;
	isMenuOpen: boolean;
	setAuthIsOpen: (isAuthOpen: boolean) => void;
	setShowInstallation: (value: boolean) => void;
	setShowLogout: (value: boolean) => void;
	onClickLogOut?: (url?: string) => void;
	setIsMenuOpen: (value: boolean) => void;
	toggleMenu: Function;
}
